import { facadeApi } from 'api'
import { PaginationParams } from 'api/common/types'
import { Project } from 'types/projects/project'

export type Params = PaginationParams<{
  tenantId: string
  projectId: string
}>

export const fetchProjectDetailsApi = ({ tenantId, projectId }: Params) =>
  facadeApi.get<Project>(`/projects/${projectId}`, {
    headers: {
      'X-Tenant-Id': tenantId,
    },
  })
